import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
} 


export const isIframe = window.self !== window.top;

// finalized_date is a timestamptz -- always a full ISO datetime string.
// Renders it as a real local date + time instead of the raw ISO string.
export function formatFinalizedDate(isoLike) {
  if (!isoLike) return '';
  const d = new Date(isoLike);
  if (Number.isNaN(d.getTime())) return isoLike;
  return d.toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
}
